document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.as-seen-in__swiper').forEach(function (container) {
    var id = container.getAttribute('id');
    var autoplay = container.dataset.autoplay === 'true';
    var delay = parseInt(container.dataset.delay || '3000', 10);
    var loop = container.dataset.loop === 'true';
    var slidesPerViewDesktop = parseInt(container.dataset.slidesPerViewDesktop || '5', 10);
    var slidesPerViewMobile = parseInt(container.dataset.slidesPerViewMobile || '2', 10);

    new Swiper('#' + id, {
      loop: loop,
      speed: 500,
      slidesPerView: slidesPerViewMobile,
      spaceBetween: 12,
      autoplay: autoplay ? { delay: delay, disableOnInteraction: false } : false,
      navigation: {
        nextEl: container.parentElement.querySelector('.as-seen-in__next'),
        prevEl: container.parentElement.querySelector('.as-seen-in__prev')
      },
      breakpoints: {
        750: { slidesPerView: Math.max(3, slidesPerViewMobile), spaceBetween: 24 },
        990: { slidesPerView: slidesPerViewDesktop, spaceBetween: 24 }
      }
    });
  });
});


